var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"input-field col",class:_vm.size},[_c('input',{staticClass:"autocomplete",attrs:{"id":_vm.id,"type":"text","disabled":_vm.disabled,"placeholder":_vm.watermark}}),_c('label',{staticClass:"active",attrs:{"id":`${_vm.id}-label`,"for":_vm.id}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }